/**
 * @ngdoc directive
 * @name moduleDispatch.directive:myDispatchSearchForm
 * @restrict 'E'
 * @element ANY
 * @priority 0
 * @scope
 **/
/* @ngInject */
const myDispatchSearchForm = (
  toaster,
  $$dispatch,
  utils
) => {
  return {
    restrict: 'E',
    scope: {
      myDispatch: '=',
      myDispatches: '=',
      enableBack: '=?',
    },
    template: require('./myDispatchSearchForm.html'),

    /* @ngInject */
    controller: ($scope) => {
      $scope.moreOptions = false
      $scope.fields = $$dispatch.metadata.fields

      $scope.search = async (_myDispatch) => {
        try {
          const myDispatch = utils.copy(_myDispatch)
          myDispatch.dateBegin = utils.date.stringToServer(myDispatch.dateBegin)
          myDispatch.dateEnd = utils.date.stringToServer(myDispatch.dateEnd)
          const response = await $$dispatch.request.getBySearch(myDispatch)
          $scope.myDispatches = response.dispatches
          toaster.message(response.message, response.color)
        } catch (error) {
          toaster.error(error)
        }
      }

      $scope.reinitForm = () => {
        $scope.myDispatches.splice(0, $scope.myDispatches.length)
        $scope.myDispatch = $$dispatch.new.search()
      }
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myDispatchSearchForm



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/dispatch/directives/forms/myDispatchSearchForm.js